<template>
  <div class="leave-plan-form">
    <form @submit.prevent="create">
      <transition name="fade">
        <div
            v-if="loading"
            class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
        >
          <loader class="center-h-v" />
        </div>
      </transition>
      <transition name="fade">
        <div
            v-if="create_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
        >
          {{ create_error }}
        </div>
      </transition>
      <transition name="fade">
        <div
            v-if="create_success"
            class="p-1 text-center text-white text-sm w-full bg-green-200"
        >
          {{ create_success }}
        </div>
      </transition>
    <div class="grid grid-cols-1 xl:grid-cols-6 md:grid-cols-6 gap-4">
       <div
           v-for="period in this.months"
           :key="period"
       >
         <label>{{ period }}</label>
         <input
             type="number"
             :id="period"
             :placeholder="`Days for ${period}`"
             @input="updatePlan(period, $event.target.value)"
             class="p-2 bg-gray-200 rounded-full w-full"
             v-model="activeLeavePlan[period]"
             :disabled="isMonthDisabled(period)"
         />
       </div>
    </div>
    <div
        class="flex justify-end p-5"
    >
      <button
          type="submit"
          class="bg-primary rounded-md px-10 text-sm text-white py-2"

      >
        Save
      </button>
    </div>
     </form>

  </div>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import decryptData from "@/utils/decrypt";
import Loader from "@/components/loader/loader.vue";

export default {
  props: {
    view: {},
    months: {},
    leavePlan: {},
    type: {},
    currentQuarter:{},
    quarters:{},

  },
  components:{
    Loader
  },
  data(){
    return {
      info:{
        Fullname:"",
        EmployeeId: "",
      },
      employees: [],
      decryptionDataLocal: "",
      loading:false,
      create_error: null,
      create_success: null,
      localLeavePlan: {},
    }
  },
  watch: {
    leavePlan: {
      handler(newPlan) {
        if (newPlan && Object.keys(newPlan).length > 0) {
          this.localLeavePlan = { ...newPlan };
        } else {
          // Initialize to an empty object if newPlan is undefined or empty
          this.localLeavePlan = {};
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getCurrentJournalId"]),
    periods() {
      return this.view === 'monthly' ? this.months : this.months;
    },
    activeLeavePlan() {
      const fallback = this.leavePlan || {};
      const defaultPlan = this.localLeavePlan[0] ?? fallback;

      const planWithDefaults = {};
      this.months.forEach((month) => {
        planWithDefaults[month] = defaultPlan?.[month] ?? 0;
      });

      return planWithDefaults;
    },
  },
  created(){
    this.decryptionKey = this.$decryptionKey;
    this.decryptionDataLocal = decryptData;
  },
  methods:{
    create(){
      this.loading = true;
      //Check if it is the first post request or it is an update of the leave plan
      const payload = this.activeLeavePlan
      console.log(payload, "payload")
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
          .post(
              `${this.getOrganization}/timeoff/plan/${this.$ApiVersion}/create`,
              JSON.stringify(payload),
              options
          )
          .then(
              (response) => {
                this.loading = false;
                if (response.data.StatusCode == 200) {
                  this.create_success = response.data.StatusMessage;
                  this.$emit("refresh-list");
                  setTimeout(() => {
                    this.create_success = null;
                  }, 2500);
                } else {
                  this.create_error = response.data.StatusMessage;
                  setTimeout(() => {
                    this.create_error = null;
                  }, 2500);
                }
              },
              (error) => {
                this.loading = false;
                this.create_error = error.message;
              }
          );
    },

    switchQuarter(quarter) {
      if (this.currentQuarter !== quarter) {
        this.currentQuarter = quarter;
      }
    },
    isMonthDisabled(period) {
      const currentMonthIndex = new Date().getMonth(); // Get current month (0 - 11)
      const periodIndex = this.months.indexOf(period);
      return periodIndex < currentMonthIndex; // Disable if the period is the current or previous month
    },
  },
mounted() {
  console.log(this.leavePlan)
}
}
</script>